import { useRouter } from 'next/router';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

export const useReviewImageProps = () => {
  const router = useRouter();
  const onClick = () => {
    router.push(UrlHelper.signup);
  };

  return { onClick, lazyImage: false };
};
